"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSentenceChildEL = exports.Sentences = exports.AttrEntry = exports.Control = void 0;
const std_1 = require("../../law/std");
class Control {
    control;
    controlRange;
    trailingSpace;
    trailingSpaceRange;
    constructor(control, controlRange, trailingSpace, trailingSpaceRange) {
        this.control = control;
        this.controlRange = controlRange;
        this.trailingSpace = trailingSpace;
        this.trailingSpaceRange = trailingSpaceRange;
    }
}
exports.Control = Control;
class AttrEntry {
    entryText;
    entry;
    entryRange;
    trailingSpace;
    trailingSpaceRange;
    constructor(entryText, entry, entryRange, trailingSpace, trailingSpaceRange) {
        this.entryText = entryText;
        this.entry = entry;
        this.entryRange = entryRange;
        this.trailingSpace = trailingSpace;
        this.trailingSpaceRange = trailingSpaceRange;
    }
}
exports.AttrEntry = AttrEntry;
class Sentences {
    leadingSpace;
    leadingSpaceRange;
    attrEntries;
    sentences;
    constructor(leadingSpace, leadingSpaceRange, attrEntries, sentences) {
        this.leadingSpace = leadingSpace;
        this.leadingSpaceRange = leadingSpaceRange;
        this.attrEntries = attrEntries;
        this.sentences = sentences;
    }
}
exports.Sentences = Sentences;
const isSentenceChildEL = (el) => (0, std_1.isControl)(el) || ["Line", "QuoteStruct", "ArithFormula", "Ruby", "Sup", "Sub"].includes(el.tag);
exports.isSentenceChildEL = isSentenceChildEL;
//# sourceMappingURL=inline.js.map